import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import EmbededFilePreview from '../../core/File/Preview';
import DocumentWriter from '../DocumentWriter';
import SmartDocumentWriter from '../SmartDocumentWriter';
import AnalyticsDashboard from '../AnalyticsDashboard';
import Utils from '../../utils';
import PlainFilePreview from './PlainFilePreview';
import HTMLFilePreview from './HTMLFilePreview';
import ImageFilePreview from './ImageFilePreview';
import EmailBodyPreview from './EmailBodyPreview';
var documentWriterSupportedExtensions = ['pdf', 'epr', 'docx', 'xfd', 'xfc', 'epb', 'fo', 'xlsx', 'sml', 'tml', 'rtf'];
var smartDocumentWriterSupportedExtensions = ['esd'];
var analyticsWriterSupportedExtensions = ['ead'];
var plainViewerSupportedExtensions = ['xml', 'sms', 'txt'];
var htmlViewerSupprtedExtensions = ['html', 'html'];
var emailBodyViewerSupprtedExtensions = ['emailbody'];
var commonViewerSupprtedExtensions = ['csv', 'ehtml'];

var extractFileExtension = function extractFileExtension(file) {
  if (!file) return '';
  return Utils.path.getFileExtension(file).toLowerCase();
};

var useDocumentWriter = function useDocumentWriter(file) {
  return documentWriterSupportedExtensions.includes(extractFileExtension(file));
};

var useSmartDocumentWriter = function useSmartDocumentWriter(file) {
  return smartDocumentWriterSupportedExtensions.includes(extractFileExtension(file));
};

var useAnalyticsDocumentWriter = function useAnalyticsDocumentWriter(file) {
  return analyticsWriterSupportedExtensions.includes(extractFileExtension(file));
};

var usePlainViewer = function usePlainViewer(file) {
  return plainViewerSupportedExtensions.includes(extractFileExtension(file));
};

var useHTMLViewer = function useHTMLViewer(file) {
  return htmlViewerSupprtedExtensions.includes(extractFileExtension(file));
};

var useEmailBodyViewer = function useEmailBodyViewer(file) {
  return emailBodyViewerSupprtedExtensions.includes(extractFileExtension(file));
};

var useCommonFilePreview = function useCommonFilePreview(file) {
  return commonViewerSupprtedExtensions.includes(extractFileExtension(file));
};
/**
 * @extends {React.Component<import('./types').FilePreviewProps>}
 */


var FilePreview =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilePreview, _React$Component);

  function FilePreview() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FilePreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilePreview)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      loaded: false
    };
    return _this;
  }

  _createClass(FilePreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          fileName = _this$props.fileName,
          accessToken = _this$props.accessToken,
          rest = _objectWithoutProperties(_this$props, ["workspace", "path", "fileName", "accessToken"]);

      if (useDocumentWriter(fileName || path)) return React.createElement(DocumentWriter, {
        workspace: workspace,
        path: path
      });
      if (useSmartDocumentWriter(fileName || path)) return React.createElement(SmartDocumentWriter, {
        workspace: workspace,
        path: path
      });
      if (useAnalyticsDocumentWriter(fileName || path)) return React.createElement(AnalyticsDashboard, {
        workspace: workspace,
        path: path,
        writerOptions: {
          hideStatusBar: true,
          hideMailIcon: true,
          hideBookmarkIcon: true,
          removeDefaultPadding: true,
          hideExportIcon: true
        }
      });
      if (usePlainViewer(fileName || path)) return React.createElement(PlainFilePreview, {
        workspace: workspace,
        path: path
      });
      if (useHTMLViewer(fileName || path)) return React.createElement(HTMLFilePreview, {
        workspace: workspace,
        path: path
      });
      if (useEmailBodyViewer(fileName || path)) return React.createElement(EmailBodyPreview, {
        workspace: workspace,
        path: path
      });
      if (useCommonFilePreview(fileName || path)) return React.createElement(EmbededFilePreview, Object.assign({}, rest, {
        workspace: workspace,
        path: path,
        fileName: fileName
      }));
      return React.createElement(ImageFilePreview, {
        workspace: workspace,
        path: path
      });
    }
  }]);

  return FilePreview;
}(React.Component);

FilePreview.defaultProps = {
  width: '100%',
  height: 'auto'
};
export default FilePreview;